import React from "react";
import "./FeaturesPage.css";

const FeaturesPage = () => {
  return (
    <div className="featurespage-root">
      <h1 className="featurespage-title">Features Page</h1>
      <p className="featurespage-description">Features Page Placeholder</p>
    </div>
  );
};

export default FeaturesPage;
